type ApiErrorData = string | { message?: unknown };

interface ApiErrorLike {
	data?: ApiErrorData;
	message?: unknown;
	response?: { data?: ApiErrorData };
}

export function apiErrorMessage(error: unknown, fallback: string): string {
	const apiError = (error || {}) as ApiErrorLike;
	const directResponseMessage =
		typeof apiError.data === 'object' && apiError.data ? apiError.data.message : undefined;
	const axiosData = apiError.response && apiError.response.data;
	const axiosResponseMessage =
		typeof axiosData === 'object' && axiosData ? axiosData.message : undefined;
	const responseMessage = directResponseMessage || axiosResponseMessage;
	if (typeof responseMessage === 'string' && responseMessage.trim()) {
		return responseMessage;
	}

	if (typeof apiError.data === 'string' && apiError.data.trim()) {
		return apiError.data;
	}
	if (typeof axiosData === 'string' && axiosData.trim()) {
		return axiosData;
	}

	if (typeof apiError.message === 'string' && apiError.message.trim()) {
		return apiError.message;
	}

	return fallback;
}
